import React, { useEffect, useState } from "react";
import Slider from "multi-range-slider-react";

import { stages } from "./Index";
import { Images } from "../../assets";
import { Button } from "../../components";
import AppDropDown from "../../components/AppDropdown";

interface CommuteFrequencyProps {
  setCurrentStage: React.Dispatch<React.SetStateAction<stages>>;
  onChange: (field: string, value: Record<string, string>) => void;
}

export default function CommuteFrequency({
  setCurrentStage,
  onChange,
}: CommuteFrequencyProps) {
  const [commuteFrequency, setCommuteFrequency] = useState("3-5");
  //go to the next stage
  const handleNextClicked = () => {
    setCurrentStage(stages.getTheReport);
  };

  //go back to the previous stage
  const handleBackClicked = () => {
    setCurrentStage(stages.commuteDistance);
  };

  useEffect(() => {
    onChange("commute", { frequency: commuteFrequency });
  }, [commuteFrequency]);

  const handleInput = ({
    minValue,
    maxValue,
  }: {
    minValue: number;
    maxValue: number;
  }) => {
    setCommuteFrequency(`${minValue}-${maxValue}`);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Form Section */}
      <div className="flex flex-col gap-8 xl:max-w-[70%] justify-center place-self-center">
        <div>
          <p className="font-bold text-2xl mb-3">Commute Frequency</p>
          <p>
            Tell us about your weekly routine! How often do you commute to work?
            Adjust the slider to match your typical schedule.
          </p>
        </div>
        <div className="flex flex-col gap-6">
          <div>
            <p>How many days per week do you commute?</p>
            <div className="w-1/2">
              <Slider
                min={1}
                max={7}
                step={1}
                minValue={3}
                maxValue={5}
                ruler={false}
                barInnerColor="black"
                labels={["1", "2", "3", "4", "5", "6", "7"]}
                style={{ border: 0, boxShadow: "none" }}
                onInput={(e) => handleInput(e)}
              />
            </div>
          </div>
          <p>
            Help us understand your commute by entering the time you typically
            leave for work and head home.
          </p>
          <div className="flex place-items-center gap-3 justify-center md:justify-start">
            <AppDropDown
              title="Departure Time"
              options={[
                "7:00 - 7:30",
                "7:30 - 8:00",
                "8:00 - 8:30",
                "Off-Peak",
              ]}
              onChange={(v) => onChange("commute", v)}
            />
            <div className="mt-4">-</div>
            <AppDropDown
              title="Return Time"
              options={[
                "5:00 - 5:30",
                "5:30 - 6:00",
                "6:00 - 6:30",
                "Off-Peak",
              ]}
              onChange={(v) => onChange("commute", v)}
            />
          </div>
        </div>
        <div className="flex gap-3 mt-6 place-items-center justify-center md:justify-start">
          <Button inverted title="Back" onClick={handleBackClicked} />
          <Button title="See My Commute Impact!" onClick={handleNextClicked} />
        </div>
      </div>

      {/* Image Section */}
      <div className="hidden md:flex justify-center items-center">
        <img
          src={Images.placeholder_Image}
          alt="placeholder image"
          className="w-full max-w-[500px] h-auto"
        />
      </div>
    </div>
  );
}
